<template>
  <div class="content-block">
    <ProjectForm
      :projectId="projectId"
      @done="onDone"
      @back="onBack"
    ></ProjectForm>
  </div>
</template>

<script>
import ProjectForm from 'CORE/components/project/form'
import isString from 'lodash/isString'
import get from 'lodash/get'

export default {
    name: 'ProjectEditView',
    components: {
        ProjectForm,
    },
    computed: {
        projectId() {
            const id = get(this.$route.params, 'id')
            console.assert(isString(id), `ID must be a string`) // TODO check if id is valid uuid or not
            return id
        },
    },
    methods: {
        onDone() {
            this.$router.push({ name: 'projectsList' })
        },
        onBack() {
            window.history.back(1)
        },
    },
}
</script>
